import {
  CompaniesInfiniteSelectField,
  FloatingFormItem,
  InputDate,
} from '@/components/_common';
import { WorkOrderCalendarDateType } from '@/core/domain/workorder/WorkOrders/WorkOrders.enum';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Col, Form, Row, Select } from 'antd';
import moment, { Moment } from 'moment';
import { useEffect } from 'react';

const dateOptions = [
  {
    value: WorkOrderCalendarDateType.Entry,
    label: 'Data de entrada',
  },
  {
    value: WorkOrderCalendarDateType.Authorization,
    label: 'Data de autorização',
  },
  {
    value: WorkOrderCalendarDateType.Close,
    label: 'Data de fechamento',
  },
  {
    value: WorkOrderCalendarDateType.Estimated,
    label: 'Data de saída prevista',
  },
  {
    value: WorkOrderCalendarDateType.Return,
    label: 'Data de entrega',
  },
];

export interface WorkOrderIndicatorsFilterValues {
  dateType: WorkOrderCalendarDateType;
  startDate: Moment;
  endDate: Moment;
  companyIds: number[];
}

interface Props {
  onChage: (values?: WorkOrderIndicatorsFilterValues) => void;
}

export default function WorkOrderIndicatorsFilter(props: Props) {
  const [form] = Form.useForm<WorkOrderIndicatorsFilterValues>();
  const formValues = Form.useWatch([], form);

  const fieldRequired = useDefaultEmptyFieldError();

  useEffect(() => {
    if (formValues?.dateType && formValues?.startDate && formValues?.endDate) {
      props.onChage({
        ...formValues,
        startDate: formValues.startDate.startOf('day'),
        endDate: formValues.endDate.endOf('day'),
      });
    } else {
      props.onChage(undefined);
    }
  }, [formValues]);

  return (
    <Form form={form}>
      <Row gutter={[24, 16]}>
        <Col span={24} md={12} lg={6}>
          <FloatingFormItem
            name="dateType"
            label="Tipo de filtro"
            initialValue={WorkOrderCalendarDateType.Entry}
            rules={[fieldRequired]}
          >
            <Select options={dateOptions} />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12} lg={6}>
          <FloatingFormItem
            name="startDate"
            label="Data inicial"
            initialValue={moment().subtract(6, 'months')}
            rules={[fieldRequired]}
          >
            <InputDate
              disabledDate={(date) =>
                !!formValues?.endDate?.isBefore(date, 'day')
              }
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12} lg={6}>
          <FloatingFormItem
            name="endDate"
            label="Data final"
            initialValue={moment()}
            rules={[fieldRequired]}
          >
            <InputDate
              disabledDate={(date) =>
                !!formValues?.startDate?.isAfter(date, 'day')
              }
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12} lg={6}>
          <FloatingFormItem name="companyIds" label="Empresas">
            <CompaniesInfiniteSelectField mode="multiple" />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
}
